
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from 'docz';
import { useState } from 'react';
import Alert from "../shared/components/Alert.js"
import Text from "../shared/components/Text.js"
import "../shared/css/index.css"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"alert"}}>{`Alert`}</MDXTag>
<MDXTag name="p" components={components}>{`Para desplegar alertas al usuario.`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const actions = [\n    \'primary\',\n    \'secondary\',\n    \'success\',\n    \'danger\',\n    \'warning\',\n    \'dark\',\n    \'light\',\n    \'info\',\n  ]\n  const [action, setAction] = useState(\'primary\')\n  const [heading, setHeading] = useState(\'Esta es una alerta!\')\n  const [alertBody, setAlertBody] = useState(\n    \'Este es el cuerpo de la Alerta, agrupado en un componente Text!\',\n  )\n\n  return (\n    <div>\n      <div>\n        <label>Action</label>\n        <select value={action} onChange={e => setAction(e.target.value)}>\n          {actions.map(actionVal => (\n            <option value={actionVal}>{actionVal}</option>\n          ))}\n        </select>\n      </div>\n      <div>\n        <label>Heading</label>\n        <input\n          type=\"text\"\n          value={heading}\n          onChange={e => setHeading(e.target.value)}\n        />\n      </div>\n      <div>\n        <label>AlertBody</label>\n        <input\n          type=\"text\"\n          value={alertBody}\n          onChange={e => setAlertBody(e.target.value)}\n        />\n      </div>\n      <Alert heading={heading} action={action}>\n        <Text>{alertBody}</Text>\n      </Alert>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,useState,Alert,Text}}>
  { () => {
    const actions = ["primary",
		"secondary",
		"success",
		"danger",
		"warning",
		"dark",
		"light",
		"info"]
const [action, setAction] = useState("primary");
const [heading, setHeading] = useState("Esta es una alerta!");
const [alertBody, setAlertBody] = useState("Este es el cuerpo de la Alerta, agrupado en un componente Text!");

return (
  <div>
    <div>
      <label>Action</label>
      <select value={action} onChange={
        (e) => setAction(e.target.value)
      }>
        { actions.map(actionVal => <option value={actionVal}>{actionVal}</option>) }
      </select>
    </div>
    <div>
      <label>Heading</label>
      <input type="text" value={heading} onChange={(e) => setHeading(e.target.value)}/>
    </div>
    <div>
      <label>AlertBody</label>
      <input type="text" value={alertBody} onChange={(e) => setAlertBody(e.target.value)}/>
    </div>
    <Alert heading={heading} action={action}>
      <Text>{alertBody}</Text>
    </Alert>
  </div>
)
  }}
</Playground>
<PropsTable of={Alert} />
           </MDXTag>
  }
}
  